<!-- 新建其他收入 -->
<template>
  <div id="ClearingBill">
    <el-button
      class="glo_bgcMainColor saveBtn"
      @click="saveData"
    >保存</el-button>
    <el-button
      v-if="detailId"
      class="glo_bgcMainColor saveBtn"
      @click="POSTING"
    >过账</el-button>

    <div
      class="formPanel"
      ref="formPanel"
    >
      <el-form
        :model="baseInForm"
        ref="baseInForm"
        :rules="baseInFormRules"
        label-width="100px"
        class="glo_formBox"
      >
        <el-form-item
          label="其他收支单号:"
          prop="number"
        >
          <el-input
            v-model="baseInForm.number"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="收支方向:"
          prop="inoutStatus"
        >
          <el-select
            v-model="baseInForm.inoutStatus"
            disabled
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in inoutStatusArr"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="费项类型:"
          prop="itemCategoryId"
        >
          <el-select
            clearable
            v-model="baseInForm.itemCategoryId"
            placeholder="请选择"
            @change="GetExpenditure"
          >
            <el-option
              v-for="(item, index) in itemCategoryIdArr"
              :key="index"
              :label="item.categoryName"
              :value="item.categoryId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="费项:"
          prop="itemServiceId"
        >
          <el-select
            v-model="baseInForm.itemServiceId"
            clearable
            remote
            :disabled="disabled_itemServiceId"
            filterable
            :remote-method="remoteItemServiceId"
            @change="GetItemServiceName"
            placeholder="输入费项名称进行匹配"
          >
            <el-option
              v-for="(item, index) in itemServiceIdArr"
              :key="index"
              :label="item.title"
              :value="item.itemServiceId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="业务网点:"
          prop="businessDeptId"
        >
          <el-select
            v-model="baseInForm.businessDeptId"
            placeholder="输入网点进行匹配"
            clearable
            remote
            filterable
            v-loadmore:loadmore="'GetDept'"
            @clear="remoteDept('')"
          >
            <el-option
              v-for="(item, index) in businessDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="结算对象类型:"
          prop="objectStatusConfDictId"
          label-width="120px"
        >
          <el-select
            clearable
            v-model="baseInForm.objectStatusConfDictId"
            @change="GetUserDownList"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in objectStatusConfDictIdArr"
              :key="index"
              :label="item.val"
              :value="item.confDictId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="结算对象:"
          prop="objectNumber"
        >
          <el-select
            v-model="baseInForm.objectNumber"
            @change="GetobjectNumber"
            clearable
            remote
            :disabled="disabled_OBJ"
            :allow-create="allowCreate"
            filterable
            :remote-method="remoteObject"
            v-loadmore:loadmore="'GetUserDownList'"
            placeholder="输入结算对象进行匹配"
          >
            <el-option
              v-for="(item, index) in objectNumberArr"
              :key="index"
              :label="item.name"
              :value="item.number"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="发生金额:"
          prop="amount"
        >
          <el-input
            v-model="baseInForm.amount"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="发生日期:"
          prop="occurrenceTime"
        >
          <el-date-picker
            v-model="baseInForm.occurrenceTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>

        <el-form-item
          label="付款方式:"
          prop="settlementMethodConfDictId"
        >
          <el-select
            v-model="baseInForm.settlementMethodConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in settlementMethodIdArr"
              :key="index"
              :label="item.val"
              :value="item.confDictId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="需要核销:"
          prop="isSettlement"
        >
          <el-select
            v-model="baseInForm.isSettlement"
            placeholder="请选择"
          >
            <el-option
              label="否"
              :value="0"
            />
            <el-option
              label="是"
              :value="1"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="单据类型:"
          prop="documentStatus"
        >
          <el-select
            v-model="baseInForm.documentStatus"
            placeholder="请选择"
            clearable
            @change="remoteSearchDoc()"
          >
            <el-option
              v-for="(item, index) in documentStatusArr"
              :key="index"
              :label="item.documentStatusShow"
              :value="item.documentStatus"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="来源单号:"
          prop="documentNumber"
        >
          <el-select
            v-model="baseInForm.documentNumber"
            filterable
            remote
            clearable
            :remote-method="remoteSearchDoc"
            @change="changeValDoc"
            placeholder="请输入关键词搜索"
          >
            <el-option
              v-for="(item, index) in documentNumberArr"
              :key="index"
              :label="item.documentShowNumber"
              :value="item.documentNumber"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="票据类型:"
          prop="invoiceTypeConfDictId"
        >
          <el-select
            v-model="baseInForm.invoiceTypeConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in invoiceTypeConfDictIdArr"
              :key="index"
              :label="item.val"
              :value="item.confDictId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="票据号码:"
          prop="invoiceNumber"
        >
          <el-input
            v-model="baseInForm.invoiceNumber"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="经办人:"
          prop="handelObjectId"
        >
          <el-select
            v-model="baseInForm.handelObjectId"
            clearable
            remote
            filterable
            v-loadmore:loadmore="'GetOperator'"
            @clear="remoteOperator('')"
            placeholder="输入姓名进行匹配"
          >
            <el-option
              v-for="(item, index) in employeeArr"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="经办时间:"
          prop="handelTime"
        >
          <el-date-picker
            v-model="baseInForm.handelTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          />
        </el-form-item>

        <el-form-item
          label="总重量:"
          prop="totalWeight"
        >
          <el-input
            v-model="baseInForm.totalWeight"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="总体积:"
          prop="totalVolume"
        >
          <el-input
            v-model="baseInForm.totalVolume"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="总数量:"
          prop="totalCount"
        >
          <el-input
            v-model="baseInForm.totalCount"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="车牌号:"
          prop="carNumber"
        >
          <el-input
            v-model="baseInForm.carNumber"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="摘要:"
          prop="remark"
        >
          <el-input
            type="textarea"
            rows="2"
            v-model="baseInForm.remark"
          />
        </el-form-item>
      </el-form>
    </div>
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
    />
    <div
      class="btns"
      ref="btns"
    >
      <el-button
        class="BillBtns"
        @click="ADDARAP"
      >添加运单</el-button>
      <el-button
        class="BillBtns"
        @click="remove"
      >移除</el-button>
    </div>
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <el-form
        :model="formData"
        ref="formData"
        v-if="isShowDialog"
        label-width="100px"
      >
        <el-form-item
          label="运单号"
          style="margin-bottom: 0px"
        >
          <el-select
            v-model="formData.waybillNumber"
            filterable
            remote
            clearable
            :remote-method="remoteSearch"
            @change="changeVal"
            :loading="loading"
            placeholder="请输入关键词"
          >
            <el-option
              v-for="item in numberArr"
              :key="item.value"
              :label="item.waybillNumber"
              :value="item.waybillNumber"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="分摊金额"
          prop="amount"
          style="margin-bottom: 0px"
        >
          <el-input
            v-model="formData.amount"
            placeholder="请输入分摊金额"
          />
        </el-form-item>
      </el-form>
    </my-dialog>
  </div>
</template>
<script >
import TablePlug from '@/components/Modules/TablePlug.vue'
import MyDialog from '@/components/Dialog.vue'
// import { log } from "console";

export default {
  inject: ['reload'],
  components: {
    TablePlug,
    MyDialog,
  },
  data() {
    return {
      objectStatusConfDictIdArr: [],
      objectNumberArr: [],
      documentNumberArr: [],
      itemCategoryIdArr: [],
      itemServiceIdArr: [],
      businessDeptIdArr: [],
      invoiceTypeConfDictIdArr: [],
      settlementMethodIdArr: [],
      inoutStatusArr: [],
      employeeArr: [],
      documentStatusArr: [],
      allowCreate: false,
      baseInForm: {
        amount: null,
        businessDeptId: null,
        documentStatus: null,
        carNumber: null,
        documentNumber: null,
        handelObjectId: null,
        handelTime: null,
        inoutStatus: 'shou_ru:inout_status',
        invoiceNumber: null,
        invoiceTypeConfDictId: null,
        isSettlement: 1,
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        occurrenceTime: null,
        remark: null,
        settlementMethodConfDictId: null,
        totalCount: null,
        totalVolume: null,
        totalWeight: null,
        number: null,
      },
      baseInFormRules: {
        itemCategoryId: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        amount: [{ required: true, message: '请输入', trigger: 'blur' }],
        itemServiceId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        businessDeptId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        objectStatusConfDictId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        objectNumber: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        occurrenceTime: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        settlementMethodConfDictId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        isSettlement: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        handelObjectId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
      defaultBaseInForm: {
        amount: null,
        businessDeptId: null,
        documentStatus: null,
        carNumber: null,
        documentNumber: null,
        handelObjectId: null,
        handelTime: null,
        inoutStatus: 'shou_ru:inout_status',
        invoiceNumber: null,
        invoiceTypeConfDictId: null,
        isSettlement: null,
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        occurrenceTime: null,
        remark: null,
        settlementMethodConfDictId: null,
        totalCount: null,
        totalVolume: null,
        totalWeight: null,
      },
      // 表格配置
      tableConfig: {
        tableHeigth: '75vh',
        tableData: [],
      },
      totalArr: ['amountMoney'],
      myTableHeard: [
        {
          name: '运单号',
          field: 'waybillNumber',
          width: '120',
          sort: 3,
          isShow: true, //是否展示
        },
        {
          name: '摊分金额',
          field: 'amountMoney',
          MultiAttr: 'Editable',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '开单备注',
          field: 'remarks',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '开单网点',
          field: 'deptName',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '开单时间',
          field: 'createTime',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '发货人',
          field: 'missFiled',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '发货人电话',
          field: 'bmissFiled',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: '收货人',
          field: 'receiveContacts',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '收货人手机',
          field: 'receivePhone',
          width: '120',
          sort: 4,
          isShow: true,
        },
        {
          name: '计费取值',
          field: 'totalBillingWeight',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '毛重',
          field: 'totalGrossWeight',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '净重',
          field: 'totalNetWeight',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '总体积',
          field: 'totalVolume',
          width: '120',
          sort: 4,
          isShow: true,
          isSort: true,
        },
        {
          name: '总件数',
          field: 'totalCount',
          width: '120',
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      diaWidth: '40%',
      dialogTitle: '提示',
      isShowDialog: false,
      loading: false,
      numberArr: [],
      CheckedData: {},
      formData: {
        amount: null,
        waybillNumber: null,
      },
      selectTableData: [],
      detailId: null,
      DefaultTableData: [],

      OperatorPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      ObjNumberPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      confDictId: null,
      disabled_itemServiceId: true,
      disabled_OBJ: true,
    }
  },
  computed: {},
  activated() {
    if (this.$route.query.xinjian == '123') {
      this.baseInForm = {
        amount: null,
        businessDeptId: null,
        documentStatus: null,
        carNumber: null,
        documentNumber: null,
        handelObjectId: null,
        handelTime: null,
        inoutStatus: 'shou_ru:inout_status',
        invoiceNumber: null,
        invoiceTypeConfDictId: null,
        isSettlement: 1,
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        occurrenceTime: null,
        remark: null,
        settlementMethodConfDictId: null,
        totalCount: null,
        totalVolume: null,
        totalWeight: null,
        number: null,
      }
    }
    // 每次进页面都会触发的写这里
    this.height()
    this.init()
  },
  created() {
    this.getConfDictValDownList('object_status')
    this.getConfDictValDownList('invoice_type')
    this.getConfDictValDownList('settlement_method')
    this.GetItemCategorChoose()
    this.GetgetDocumentStatusList()
    // this.GetStatusValList("bill_finance_other_in_v3.document_status");
    this.GetStatusValList('bill_finance_other_in_v3.inout_status')
    this.GetDept()
    this.firstINit()
  },
  watch: {
    // $route(to, from) {
    //   let id = this.$route.query.otherId || "";
    //   // if (to.fullPath == "/FM/NewOtherIncome/1") {
    //   //   this.$refs["baseInForm"].resetFields();
    //   //   this.selectTableData.length = 0;
    //   //   this.tableConfig.tableData = [];
    //   //   this.baseInForm.occurrenceTime = this.$TOOLS.getCurrentTime();
    //   //   this.baseInForm.handelTime = this.$TOOLS.getCurrentTime();
    //   // }
    //   if (id) {
    //     this.$refs["baseInForm"].resetFields();
    //     this.selectTableData.length = 0;
    //     this.tableConfig.tableData = [];
    //     this.detailId = this.$route.query.otherId || "";
    //     this.GetOtherDetail();
    //     this.GetOtherInWaybillList();
    //   }
    // },
    'baseInForm.itemCategoryId': {
      handler(nv, ov) {
        if (!nv) {
          this.disabled_itemServiceId = true
        } else {
          this.disabled_itemServiceId = false
        }
      },
    },
    'baseInForm.objectStatusConfDictId': {
      handler(nv, ov) {
        if (!nv) {
          this.disabled_OBJ = true
        } else {
          this.disabled_OBJ = false
        }
      },
    },
  },
  methods: {
    async firstINit() {
      this.baseInForm.occurrenceTime = this.$TOOLS.getCurrentTime()
      this.baseInForm.handelTime = this.$TOOLS.getCurrentTime()
      let UserInfo = this.$TOOLS.getUserInfo() || ''
      this.baseInForm.businessDeptId = UserInfo.departmentId || ''
      await this.GetOperator(UserInfo.employeeName)
      this.employeeArr.forEach((element) => {
        if (element.name == UserInfo.employeeName) {
          this.baseInForm.handelObjectId = element.documentId || ''
        }
      })
    },
    async init() {
      this.detailId = this.$route.query.otherId || ''
      if (this.detailId) {
        this.GetOtherDetail()
        this.GetOtherInWaybillList()
      }
    },
    // 获取结算对象类型 & 票据类型 & 付款方式
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === 'success') {
          if (PARAM === 'object_status') {
            this.objectStatusConfDictIdArr = res.data.result || []
          }
          if (PARAM === 'invoice_type') {
            this.invoiceTypeConfDictIdArr = res.data.result || []
          }
          if (PARAM === 'settlement_method') {
            this.settlementMethodIdArr = res.data.result || []
          }
        } else {
          console.log(res.data.message)
        }
      })
    },

    // 获取经办人
    GetOperator(e, checkedData) {
      let query = {
        key: 'employee',
        name: e,
        id: checkedData,
        pageStart: this.OperatorPage.pageStart,
        pageTotal: this.OperatorPage.pageTotal,
      }
      return this.$API.wtl_getObjectUserDownList(query).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          let arr = this.employeeArr
          if (e) {
            this.employeeArr = result
          } else {
            this.employeeArr = [
              ...arr,
              ...result.filter(
                (item) => !arr.some((x) => x.documentId === item.documentId)
              ),
            ]
          }
          if (!e && !checkedData) {
            this.OperatorPage.pageCount = res.data.result?.pageCount || 0
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 经办人远程搜索
    remoteOperator(e) {
      this.OperatorPage.pageStart = 1
      if (e !== '') {
        this.GetOperator(e)
      } else {
        this.GetOperator()
      }
    },
    // 滚动条加载更多
    loadmore(e) {
      let definePage =
        e === 'GetOperator'
          ? 'OperatorPage'
          : 'GetUserDownList'
          ? 'ObjNumberPage'
          : 'GetDept'
          ? 'DeptPage'
          : ''
      let count = this[definePage].pageCount / this[definePage].pageTotal
      if (count > this[definePage].pageStart) {
        this[definePage].pageStart += 1
        this[e.replace(/[0-9]+/g, '')]()
      } else {
        console.log('数据已全部加载')
      }
    },
    // 根据结算对象类型获取结算对象（parentId是对象类型）
    GetUserDownList(parentId, e, checkedData) {
      if (!parentId && !e && !checkedData) {
        this.baseInForm.objectNumber = ''
        return false
      }
      this.objectNumberArr = []
      this.ObjNumberPage.pageStart = 1
      this.ObjNumberPage.pageCount = 0
      this.confDictId = parentId
        ? parentId
        : checkedData
        ? checkedData
        : this.confDictId
      if (parentId) {
        this.baseInForm.objectNumber = ''
      }
      this.allowCreate = false
      // 根据获取的结算对象类型ID获取对应的key值
      let arr = this.objectStatusConfDictIdArr
      let num = arr.findIndex(
        (element) => element.confDictId == this.confDictId
      )
      let objectKey = arr[num].key
      // 当结算对象类型为 其他 的时候结算对象选择框可手动输入
      if (objectKey == 'other') {
        this.allowCreate = true
        this.baseInForm.objectNumber = ''
        this.objectNumberArr = []
      } else {
        let query = {
          key: objectKey,
          name: e,
          id: checkedData,
          pageStart: this.ObjNumberPage.pageStart,
          pageTotal: this.ObjNumberPage.pageTotal,
        }
        this.$API.wtl_getObjectUserDownList(query).then((res) => {
          if (res.data.status === 'success') {
            let result = res.data.result?.data || []
            let arr = this.objectNumberArr
            if (e) {
              this.objectNumberArr = result
            } else {
              this.objectNumberArr = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.documentId === item.documentId)
                ),
              ]
            }
            if (!e && !checkedData) {
              this.ObjNumberPage.pageCount = res.data.result?.pageCount || 0
            }
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    // 结算对象远程搜索
    remoteObject(e) {
      this.ObjNumberPage.pageStart = 1
      if (e !== '') {
        this.GetUserDownList(null, e, null)
      } else {
        this.GetUserDownList()
      }
    },
    // 获取结算对象名称
    GetobjectNumber(e) {
      if (e) {
        if (this.baseInForm.objectStatusConfDictId == '7') {
          // 当结算对象类型为其他时，结算对象编号为空，只上传结算对象名称
          this.baseInForm.objectName = e
        } else {
          let index = this.objectNumberArr.findIndex(
            (element) => element.number == e
          )
          this.baseInForm.objectName = this.objectNumberArr[index].name
        }
      } else {
        this.remoteObject()
      }
    },

    // 获取费项类型下拉列表
    GetItemCategorChoose() {
      this.$API.itemCategorChoose().then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result || []
          this.itemCategoryIdArr = result
        }
      })
    },
    // 费项远程搜索
    remoteItemServiceId(e) {
      this.$message.warning('暂无数据')
      // if (e !== "") {
      //   this.getDeptList(e);
      // } else {
      //   this.getDeptList();
      // }
    },
    // 根据类别和费项类型获取费项
    GetExpenditure(e, opt) {
      if (e) {
        let index = this.itemCategoryIdArr.findIndex(
          (element) => element.categoryId == e
        )
        this.baseInForm.itemCategoryName =
          this.itemCategoryIdArr[index].categoryName
        this.$API.CategoryServiceList({ categoryId: e }).then((res) => {
          if (res.data.status === 'success') {
            let result = res.data.result || []
            // 回显
            if (opt !== 'echo') {
              this.baseInForm.itemServiceId = ''
            }
            this.itemServiceIdArr = result
          }
        })
      } else {
        this.baseInForm.itemServiceId = ''
        this.itemServiceIdArr = []
      }
    },

    // 获取费项名称
    GetItemServiceName(e) {
      let index = this.itemServiceIdArr.findIndex(
        (element) => element.itemServiceId == e
      )
      this.baseInForm.itemServiceName = this.itemServiceIdArr[index].title
    },

    // 获取业务网店（组织架构列表）
    GetDept(e, checkedData) {
      let query = {
        deptName: e,
        deptId: checkedData,
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
      }
      this.$API.wtl_getDeptList(query).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result?.data || []
          let arr = this.businessDeptIdArr
          if (e) {
            this.businessDeptIdArr = result
          } else {
            this.businessDeptIdArr = [
              ...arr,
              ...result.filter(
                (item) => !arr.some((x) => x.deptId === item.deptId)
              ),
            ]
          }
          if (!e && !checkedData) {
            this.DeptPage.pageCount = res.data.result?.pageCount || 0
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    remoteDept(e) {
      this.OperatorPage.pageStart = 1
      if (e !== '') {
        this.GetDept(e)
      } else {
        this.GetDept()
      }
    },
    // 获取详情
    GetOtherDetail() {
      this.$API.OtherInDetail({ otherId: this.detailId }).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result || {}
          this.$nextTick(() => {
            this.baseInForm = result
            if (result.objectStatusConfDictId) {
              this.GetUserDownList('', '', result.objectStatusConfDictId)
            }
            if (result.itemCategoryId) {
              this.GetExpenditure(result.itemCategoryId, 'echo')
            }
            if (result.documentNumber) {
              this.remoteSearchDoc(result.documentNumber)
            }
          })
        }
      })
    },

    // 获取下方表格运单的信息
    GetOtherInWaybillList() {
      this.$API.OtherInWaybillList({ otherId: this.detailId }).then((res) => {
        if (res.data.status === 'success') {
          let result = res.data.result || []
          for (let u in result) {
            result[u].amountMoney = result[u].amount || 0
            let _result = {}
            _result.operationType = 'UNCHANGED'
            _result.waybillSplitId = result[u].waybillSplitId
            _result.amount = result[u].amount || 0
            this.DefaultTableData.push(_result)
          }
          this.tableConfig.tableData = result
        }
      })
    },
    // 获取对象单据类型
    GetgetDocumentStatusList() {
      this.$API
        .getDocumentStatusList({ pageStart: 1, pageTotal: 200 })
        .then((res) => {
          if (res.data.status === 'success') {
            let result = res.data.result.data || []
            this.documentStatusArr = result
          }
        })
    },
    // 获取对象单据类型
    GetStatusValList(str) {
      this.$TOOLS.getStatusValList(str).then((res) => {
        // if (str === "bill_finance_other_in_v3.document_status") {
        //   this.documentStatusArr = res;
        // }
        if (str === 'bill_finance_other_in_v3.inout_status') {
          this.inoutStatusArr = res
        }
      })
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e
    },

    // 保存
    saveData(t) {
      // 正常提交
      let param = {
        waybills: [],
      }
      if (this.detailId) {
        // 修改
        let defaultBaseInForm = {
          amount: null,
          businessDeptId: null,
          documentStatus: null,
          carNumber: null,
          documentNumber: null,
          handelObjectId: null,
          handelTime: null,
          inoutStatus: 'shou_ru:inout_status',
          invoiceNumber: null,
          invoiceTypeConfDictId: null,
          isSettlement: null,
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          objectName: null,
          objectNumber: null,
          objectStatusConfDictId: null,
          occurrenceTime: null,
          remark: null,
          settlementMethodConfDictId: null,
          totalCount: null,
          totalVolume: null,
          totalWeight: null,
        }
        for (let key in defaultBaseInForm) {
          if (this.baseInForm[key] || this.baseInForm[key] == 0) {
            eval('param.' + key + "='" + this.baseInForm[key] + "'")
          } else {
            eval('param.' + key + "=''")
          }
        }

        for (let i in this.tableConfig.tableData) {
          param.waybills.push({
            amount: this.tableConfig.tableData[i].amountMoney,
            waybillSplitId: this.tableConfig.tableData[i].waybillSplitId,
            operationType: 'UPDATE',
          })
        }

        param.operationType = 'SAVE'
        param.otherId = this.detailId
        if (t === 'positing') param.operationType = 'POSTING'
        this.$API.updateOtherIn(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.$TOOLS.closePage()
            this.$router.push({
              path: '/FM/OtherIncome',
              query: {
                isreload: 'isreload',
              },
            })
          }
        })
      } else {
        // 新建
        for (let key in this.defaultBaseInForm) {
          if (this.baseInForm[key] || this.baseInForm[key] == 0) {
            eval('param.' + key + "='" + this.baseInForm[key] + "'")
          } else {
            eval('param.' + key + "=''")
          }
        }
        for (let i in this.tableConfig.tableData) {
          param.waybills.push({
            amount: this.tableConfig.tableData[i].amountMoney,
            waybillSplitId: this.tableConfig.tableData[i].waybillSplitId,
          })
        }
        param.operationType = 'SAVE'
        this.$API.addOtherIn(param).then((res) => {
          if (res.data.status === 'success') {
            this.$message.success(res.data.message)
            this.$TOOLS.closePage()
            this.$router.push({
              path: '/FM/OtherIncome',
              query: {
                isreload: 'isreload',
              },
            })
          }
        })
      }
    },
    // 过账
    POSTING() {
      this.saveData('positing')
    },
    // 表格移除事件
    remove(event, opt) {
      if (opt) this.selectTableData = [opt]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确认移除所选数据?', '提示:')
          .then((res) => {
            let data = this.selectTableData
            let TD = this.tableConfig.tableData
            for (let i in data) {
              // 查找到表格里的数据对其删除 、 查找到默认表格数据中的operationType对其重新赋值
              let index = data.findIndex(
                (element) => element.waybillSplitId == data[i].waybillSplitId
              )
              let D_index = this.DefaultTableData.findIndex(
                (elem) => elem.waybillSplitId == data[i].waybillSplitId
              )
              if (D_index != -1) {
                this.DefaultTableData[D_index].operationType = 'DEL'
              }
              this.tableConfig.tableData.splice(index, 1)
            }
            this.selectTableData = []
          })
          .catch((err) => {
            if (opt) this.selectTableData.length = 0
          })
      }
    },
    // 添加运单
    ADDARAP() {
      this.isShowDialog = true
    },

    // 运单号远程搜索
    remoteSearch(query) {
      if (query !== '') {
        let getReq = {
          waybillNumber: query,
        }
        this.$API.WaybillListByNumber(getReq).then((res) => {
          if (res.data.status === 'success') {
            this.loading = false
            this.numberArr = res.data.result || []
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.numberArr = []
      }
    },

    // 远程搜索值改变的时候
    changeVal(e) {
      this.CheckedData = {}
      let arr = this.numberArr
      let index = arr.findIndex((element) => element.waybillNumber == e)
      if (this.numberArr[index]) this.CheckedData = this.numberArr[index]
    },
    // 来源单据选中触发
    changeValDoc() {},

    // 来源单据远程搜索
    remoteSearchDoc(query) {
      // let getReq = {
      //   documentNumber: query,
      //   documentStatus: this.baseInForm.documentStatus || "",
      // };
      // this.$API.FinanceInAllList(getReq).then((res) => {
      //   if (res.data.status === "success") {
      //     this.loading = false;
      //     this.documentNumberArr = res.data.result?.data || [];
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
      this.$API
        .getDocumentBillsList({
          key: this.baseInForm.documentStatus || '',
          number: query,
        })
        .then((res) => {
          if (res.data.status === 'success') {
            this.loading = false
            this.documentNumberArr = res.data.result?.data || []
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia()
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.$refs['formData'].resetFields()
      this.isShowDialog = false
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      let arr = Object.keys(this.CheckedData)
      let index = this.tableConfig.tableData.findIndex(
        (element) => element.waybillSplitId == this.CheckedData.waybillSplitId
      )
      let Dindex = this.DefaultTableData.findIndex(
        (e) => e.waybillSplitId == this.CheckedData.waybillSplitId
      )
      if (Dindex != -1) {
        this.DefaultTableData[Dindex].operationType = 'UNCHANGED'
      }
      if (arr.length !== 0 && index == -1) {
        this.CheckedData.amountMoney = this.formData.amount
        let getarr = JSON.parse(JSON.stringify(this.CheckedData))
        let getrr1 = JSON.parse(JSON.stringify(this.tableConfig.tableData))
        this.tableConfig.tableData = [...getrr1, ...[getarr]]
        this.$refs['formData'].resetFields()
        this.isShowDialog = false
      } else {
        this.$message.warning('数据重复或不存在')
        return false
      }
    },
    height() {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight
      let queryHeigth = this.$refs.formPanel.offsetHeight + 50
      let btnListHeight = this.$refs.btns.offsetHeight
      let pagsHeigth = 40 + 20
      let otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60
      this.$nextTick(() => {
        this.tableConfig.tableHeigth = Math.floor(windonHeight - otherHeight)
      })
    },
  },
}
</script>
<style scoped lang="less">
#ClearingBill {
  .saveBtn {
    padding: 10px 20px;
  }
  .formPanel {
    padding: 10px 20px;
    margin: 12px 0;
    background: rgba(0, 0, 0, 0.05);
    /deep/ .el-form-item {
      background: #fff !important;
    }
  }
  .btns {
    background: rgba(0, 0, 0, 0.05);
    .BillBtns {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 10px;
      margin: 8px 0;
      margin-left: 10px;
    }
    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
}
</style>

